module.exports = __webpack_public_path__ + "img/eduzz.fc2b8b04.svg";